import { PlanAmendmentDetails } from '@/api/api.types'
import { EQueryKeys } from '@/constants'

import useApiHook from '@/hooks/useApiHook'

export default function useGetPlanWithAmendments(planId: string | undefined) {
  const isGetPlanEnabled = !!planId
  const { useGetPlan, useGetPlanAmendmentDetails } = useApiHook()

  const amendmentDetails = useGetPlanAmendmentDetails(
    { planId: planId as string },
    { enabled: isGetPlanEnabled, queryKey: [EQueryKeys.PLAN_AMENDMENT_DETAILS, planId] },
  )

  const newPlanId = isAmendmentWithNewPlan(amendmentDetails.data) ? amendmentDetails.data.newPlanId : undefined
  const hasPendingPlanChange = !!newPlanId

  const newPlan = useGetPlan(
    { planId: newPlanId },
    {
      enabled: hasPendingPlanChange,
      queryKey: [EQueryKeys.PLAN, newPlanId],
    },
  )

  return {
    amendmentDetails,
    newPlan,
  }
}

export function isAmendmentWithNewPlan(
  amendmentDetails?: PlanAmendmentDetails,
): amendmentDetails is Extract<PlanAmendmentDetails, { canAmend: false; newPlanId: string }> {
  return (
    !!amendmentDetails &&
    'newPlanId' in amendmentDetails &&
    amendmentDetails.newPlanId !== undefined &&
    amendmentDetails.canAmend === false
  )
}
